
import { Component, Watch } from 'vue-property-decorator';

import { mapGetters, mapState } from 'vuex';

import { parseFloatCustom } from '@/config/functions';

import jsPDF from 'jspdf';

import '@/config/Roboto-normal';

import autoTable from 'jspdf-autotable';

import * as Excel from 'exceljs';

import { downloadBlob } from 'download.js';

import { striposMixin } from '@/mixins/striposMixin.js';

import { colorTooltipsMixin } from '@/mixins/colorTooltipsMixin.js';
import BasePage from '@/components/BasePage';
import { first, sortBy } from 'lodash';
import { SupplierResponse } from '@/interfaces/Suppliers';

@Component({
   filters: {
      reduce_sum: (items: any[], index: string | number) =>
         items.length ? items.map(a => (a[index] != '' ? parseFloatCustom(a[index]) : 0)).reduce((a, b) => a + b) : 0,
   },
   computed: {
      ...mapGetters({
         suppliers: 'suppliers/active',
      }),
      ...mapState({
         dataReady: (s: any) => s.ready,
         user_roles: (s: any) => s.users.roles,
         activities_colors: (s: any) => s.activities.colors,
         payment_colors: (s: any) => s.activities.paymentColors,
      }),
   },
   mixins: [striposMixin, colorTooltipsMixin],
})
export default class Booking extends BasePage {
   suppliers!: SupplierResponse[];

   addColorTooltips!: any;

   stripos!: any;

   dataReady!: boolean;

   form: any = null;

   user_roles!: number[];

   activities_colors!: any[];

   payment_colors!: any[];

   default_colors: any = {
      o_act_color: '#FEFEFE',
      o_group_color: '#FEFEFE',
      acс_status: '#ffffff',
      act_status: '#ffffff',
      task_status: '#ffffff',
      transfer_status: '#ffffff',
      guide_status: '#ffffff',
      act_patment_status: '#ffffff',
      moto_overal_status: '#ffffff',
      acс_payment_status: '#ffffff',
      transfer_payment_status: '#ffffff',
      o_overal_status: '#ffffff',
   };

   filter!: any;

   fields!: any[];

   filtered!: any[];

   params: any = {};

   tbodyTrAttr(row: any) {
      return {
         'data-date': this.formatterDate(row.o_check_in_date ?? row.due_date ?? row.acс_checkin_date ?? row.act_day),
      };
   }

   tbodyTrClass(row: any) {
      return [
         this.formatterDate(row.o_check_in_date ?? row.acс_checkin_date ?? row.act_day ?? row.due_date) == this.$moment().format('YYYY-MM-DD')
            ? 'today'
            : '',
         row?.is_archived ? 'bg-archive' : '',
      ];
   }

   download(type: string, sort: string, filename: string | string[] | Date[]) {
      if (Array.isArray(filename)) {
         filename = filename.map((r: string | Date) => this.$moment(r).format('DD.MM.YYYY')).join('-');
      }

      const $body = this.downloadData(sort);

      const $fields = this.fields
         .filter((f: any) => !['transfer_name'].includes(f.key))
         .map((f: any) => ({
            header: f.label.toUpperCase(),
            key: f.key,
            hidden: false,
            width: ['moto_lead_guest'].includes(f.key) ? 32 : 12,
         }));

      // @ts-ignore
      this.__download(type, $fields, $body, filename);
   }

   downloadData(sort: string) {
      const keys = this.fields.filter((f: any) => !['transfer_name'].includes(f.key)).map((f: any) => f.key);
      const filtered = sortBy(this.filtered, sort);

      return filtered.map((item: any) => {
         const result: any[] = [];

         for (const key of keys) {
            let value = item[key] ? item[key] : '';

            switch (key) {
               case 'act_time':
               case 'act_pickup_time':
                  value = this.formatTime(item[key]);
                  break;

               case 'transfer_status':
                  value = typeof item.act_time != 'undefined' ? this.formatTime(item.act_time) : '';
                  break;

               case 'act_day':
               case 'activity_day':
                  value = this.$moment(item[key]).format('DD.MM.YYYY');
                  break;

               case 'supplier_id':
                  value = this.supplierName(item[key]);
                  break;

               case 'guide_status':
                  value = this.$options.filters?.getColor(this.activities_colors, item[key]);
                  break;

               case 'act_patment_status':
                  value = this.$options.filters?.getColor(this.payment_colors, item[key]);
                  break;

               case 'o_stay_in.o_name':
                  value = [item[key], item.o_stay_in != 161785 ? item['o_stay_in.o_hotel.o_hotaddress'] : item.o_self_arranged_notes].join(' ');
                  break;

               case 'acс_checkin_date':
                  value = this.$moment(item.acс_checkin_date).format(this.customFormatter.dateFormat);
                  break;

               case 'acс_status':
                  if (item.acс_status_name != '' && item.acс_status != '') {
                     value = item.acс_status_name;
                  }
                  break;

               case 'acс_cost':
                  value = this.$options.filters?.toFixed(item.acс_cost);
                  break;

               case 'o_active':
               case 'o_addtoprice':
               case 'o_adrenaline':
                  value = item[key] == 1 ? '+' : '';
                  break;
            }

            if (value === null) {
               value = '';
            }

            result.push({ key, value, label: this.fields.filter(i => i.key == key)[0]['label'] });
         }

         return result;
      });
   }

   async __download(type: string = 'pdf', $fields: any[], $data: any[], filename: string) {
      this.$store.commit('showLoading');

      switch (type) {
         case 'pdf':
            await this.__downloadPdf($fields, $data, filename + '.pdf');
            break;
         case 'xls':
            await this.__downloadXls($fields, $data, filename + '.xlsx');
      }
      setTimeout(() => this.$store.commit('hideLoading'), 500);
   }

   async __downloadPdf($fields: any[], $data: any[], filename: string) {
      const doc = await new jsPDF({
         orientation: 'landscape',
         format: 'a3',
      });

      const styles = { font: 'Roboto', fontStyle: 'normal', fontSize: 8 };
      await doc.setFont('Roboto', 'normal');
      await doc.setFontSize(8);

      const body = $data.map((field: any) => {
         return field.map((f: any) => ({
            content: f.value || '',
            styles,
            ...(typeof f.value == 'string' && /^#?[0-9A-F]{3,6}$/i.test(f.value.trim())
               ? {
                    content: typeof f.value == 'string' ? f.value : '',
                    styles: { textColor: '#' + f.value.replace('#', ''), fontSize: 8, font: 'PTSans-Regular' },
                 }
               : {}),
         }));
      });

      await doc.text('Generated on ' + this.$moment().format('DD.MM.YYYY HH:MM'), 252, 5);

      await autoTable(doc, {
         // @ts-ignore
         headStyles: {
            ...styles,
            fillColor: '#D5E9FA',
            textColor: '#000000',
            halign: 'center',
            valign: 'middle',
         },
         bodyStyles: {
            halign: 'center',
         },
         margin: { top: 7, left: 5, bottom: 5, right: 5 },
         head: [$fields.map(f => f.header)],
         body,
      });

      await doc.save(filename);
   }

   async __downloadXls($fields: any[], $data: any[], filename: string) {
      let workbook = await new Excel.Workbook();

      workbook.created = new Date();
      workbook.modified = new Date();
      workbook.lastPrinted = new Date();

      const worksheet = await workbook.addWorksheet('Publications');
      worksheet.views = [{ state: 'frozen', xSplit: 0, ySplit: 2 }];

      worksheet.autoFilter = {
         from: 'A2',
         to: {
            row: $data.length + 2,
            column: $fields.length,
         },
      };

      worksheet.columns = $fields as Excel.Column[];

      await worksheet.addRows($data.map(d => d.map((dd: any) => dd.value)));

      await workbook.eachSheet(async worksheet => {
         await worksheet.eachRow(async (row, rowNumber) => {
            if (rowNumber > 1) {
               for (let i = 1; i <= row.cellCount; i++) {
                  let cell = row.getCell(i);
                  if (typeof cell.value == 'string') {
                     if (/^#?[0-9A-F]{3,6}$/i.test(cell.value.trim())) {
                        cell.fill = {
                           type: 'pattern',
                           pattern: 'solid',
                           fgColor: { argb: cell.value.trim().replace('#', '') },
                        };
                        cell.value = '';
                     } else if (this.$moment(cell.value.trim(), 'DD.MM.YYYY').isValid()) {
                        cell = {
                           ...cell,
                           type: 4,
                           value: new Date(this.$moment(cell.value.trim(), 'DD.MM.YYYY').format()),
                           style: {
                              numFmt: 'dd.mm.yyyy',
                           },
                        };
                     } else if (cell.value.trim() == 'null' || cell.value.trim() == '0') {
                        cell.value = '';
                     }
                  }
               }
            }

            await row.eachCell(cell => {
               cell.alignment = { wrapText: true };
            });
         });
      });

      let data = Object.keys($fields).map(f => '');
      data.pop();
      data.push('Generated on ' + this.$moment().format('DD.MM.YYYY HH:MM'));

      await worksheet.insertRow(1, data);

      await workbook.xlsx.writeBuffer({ useStyles: true }).then(data => {
         let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
         downloadBlob(filename, blob);
      });
   }

   supplierName(o_id: number) {
      return first(this.suppliers.filter(item => item.o_id == o_id))?.o_name;
   }

   @Watch('filter.today')
   changeFilterToday(n: number) {
      if (n == 1) {
         const findNearestDate = (): Date => {
            const today = new Date().getTime();
            const closestDate: any[] = [new Date(), Infinity];

            document.querySelectorAll('tr[data-date]').forEach(item => {
               const date = new Date(item.getAttribute('data-date') as string);
               const difference = Math.abs(date.getTime() - today);

               if (difference < closestDate[1]) {
                  closestDate[0] = date;
                  closestDate[1] = difference;
               }
            });

            return closestDate[0];
         };

         const date = this.formatterDate(findNearestDate());
         const element = document.querySelector(`tr[data-date="${date}"]`);

         if (element) {
            const top = element.getBoundingClientRect().top + window.scrollY;
            window.scroll({ top, behavior: 'smooth' });
         }
      }
   }
}
